import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController, PopoverController } from 'ionic-angular'; 
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { VerglasungtypePage } from '../verglasungtype/verglasungtype';
import { UserserviceProvider } from '../../providers/userservice';
import { SprossenPage } from '../sprossen/sprossen';
import { QuickviewPage } from '../quickview/quickview';



@Component({
  selector: 'page-verglasung',
  templateUrl: 'verglasung.html',
})
export class VerglasungPage {
productname: string;
producttype: string;
windowtype: string;
typeopen: string
windowlong: string;
windowwide: string;
dichtungen: string;
dekorfarbe: string;
dichtungen: string;
outColorIn: string;
outColorOut: string;
selectedGriffe: string;
selectedOrnament: any; 
selectedVerglasung: any; 
selectedKante: string;
verglasung_cat: any;
glas: any; 
kante: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController, public popoverCtrl: PopoverController )  {
  
    this.selectedKante = "keine";
  
    this.selectedGriffe = this.navParams.get('selectedGriffe');
    this.dichtungen = this.navParams.get('dichtungen');
    this.outColorIn = this.navParams.get('outColorIn');
    this.outColorOut = this.navParams.get('outColorOut');
    this.typeopen = this.navParams.get('typeopen');
    this.windowtype = this.navParams.get('windowtype');
    this.productname = this.navParams.get('productname');
    this.producttype = this.navParams.get('producttype');
    this.windowlong = this.navParams.get('windowlong');
    this.windowwide = this.navParams.get('windowwide');
    console.log( this.productname, this.producttype, this.windowtype, this.typeopen, this.windowlong, this.windowwide, this.dichtungen, this.outColorIn, this.outColorOut, this.selectedGriffe); 
    
  } 
  
    presentQuickView() {
    this.myChoice = {productname: this.productname, producttype :this.producttype, windowtype:this.windowtype, typeopen:this.typeopen, windowlong: this.windowlong, windowwide: this.windowwide, outColorIn:this.outColorIn, outColorOut:this.outColorOut, dichtungen: this.dichtungen, selectedGriffe:this.selectedGriffe }
    const popover = this.popoverCtrl.create(QuickviewPage, this.myChoice, {cssClass: 'popover-top-right'});
    popover.present();
  } 
  
    presentModalVerglasung(verglasung_cat) {
    let glasModal = this.modalCtrl.create(VerglasungtypePage, {
      'selectedVerglasung': this.selectedVerglasung,
      'selectedOrnament': this.selectedOrnament,
       verglasung_cat: verglasung_cat,
    });
    glasModal.onDidDismiss(data => {
      this.selectedVerglasung = data.glases;
      this.selectedOrnament = data.glases2;
      //this.griffe_img = data.griffe_img;
    });
    glasModal.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VerglasungPage');
  }
  
        ionViewWillEnter() : void
   {
    //this.getVerglasung();
   }
   
   selectKante(kante) {
   this.selectedKante = kante;
   console.log(this.selectedKante); 
   }
   
    clickglas(selectedVerglasung, selectedOrnament) {
    this.navCtrl.push(SprossenPage, {
    selectedVerglasung: selectedVerglasung,
    selectedKante: this.selectedKante,
    selectedOrnament: selectedOrnament,
    selectedGriffe: this.selectedGriffe,
    dichtungen: this.dichtungen,
    outColorIn: this.outColorIn,
    outColorOut: this.outColorOut,
    typeopen: this.typeopen,
    windowtype: this.windowtype,
    productname: this.productname,
    producttype: this.producttype,
    windowlong: this.windowlong,
    windowwide: this.windowwide
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/verglasung/verglasung.ts